import React from "react";
import {
  FeaturedCustomersBase,
  Subtitle,
  Images,
  Image,
  ImageLink,
} from "./featured-customers.styled";
import { FeaturedCustomersSliceFragment } from "../../types/graphql";
import { PrismicRichText, SliceComponentProps } from "@prismicio/react";
import { htmlSerializer } from "../../utils/htmlSerializer";
import { Slice } from "@prismicio/types";
import { IPageContext } from "../../types/types";
import { SharedSliceType } from "../shared-slice/shared-slice";

export type IFeaturedCustomersProps = Slice<
  SharedSliceType,
  FeaturedCustomersSliceFragment["primary"],
  FeaturedCustomersSliceFragment["items"][number]
> & { type: SharedSliceType.featured_customers };

const FeaturedCustomers = ({
  slice,
}: SliceComponentProps<IFeaturedCustomersProps, IPageContext>) => {
  const subtitle = slice.primary?.subtitle;
  const customers = slice.items;

  return (
    <>
      <FeaturedCustomersBase>
        {customers && (
          <Images>
            {customers.map((customer, index) => {
              return (
                customer?.company_link?.url && (
                  <ImageLink
                    key={index}
                    href={customer.company_link?.url}
                    target={customer.company_link?.target || ""}
                  >
                    {customer?.company_logo?.url && (
                      <Image
                        width={customer.company_logo.dimensions?.width}
                        height={customer.company_logo.dimensions?.height}
                        src={customer.company_logo.url}
                        alt={customer.company_logo.alt || "Xometry Image"}
                      />
                    )}
                  </ImageLink>
                )
              );
            })}
          </Images>
        )}
        {subtitle && (
          <Subtitle>
            <PrismicRichText
              field={subtitle.richText}
              components={htmlSerializer}
            />
          </Subtitle>
        )}
      </FeaturedCustomersBase>
    </>
  );
};

export default FeaturedCustomers;
